import React, { Component } from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import { Link, injectIntl } from "gatsby-plugin-intl";
import Layout from "../components/layout/Layout";
import Section from "../components/section/Section";
import Grid from "../components/grid/Grid";
import SpokenLanguageList from "../components/lists/SpokenLanguageList";
import ExpandableList from "../components/lists/ExpandableList";
import BackArrow from "../assets/BackArrow";
import cssClass from "./teamMember.module.scss";

class TeamMember extends Component {
  render() {
    const { data, pageContext, location } = this.props;

    const {
      name,
      image,
      title,
      statement,
      specialties,
      diseasesTreated,
      spokenLanguages,
      experience,
      training,
      metaDescription,
    } = data.contentfulTeamMember;

    const {
      backToClinicLink,
      specialtiesTitle,
      diseasesTreatedTitle,
      experienceTitle,
      trainingTitle,
    } = data.contentfulTeamMemberPage;

    const seo = {
      title: `${name} - ${pageContext.clinicName}`,
      description: metaDescription,
      url: location.href,
    };

    return (
      <Layout seo={seo} underNav>
        <Section bottomVerticalPadding>
          <Link
            to={`/${pageContext.clinicSlug}`}
            className={cssClass.backToClinicLink}
          >
            <span className={cssClass.backArrow}>
              <BackArrow />
            </span>
            {backToClinicLink}
          </Link>
          <Grid>
            <div className={cssClass.imageWrapper}>
              <Img
                className={cssClass.teamMemberImage}
                fluid={image.fluid}
                alt={image.title}
              />
            </div>

            <div className={cssClass.content}>
              <div className={cssClass.intro}>
                <h1 className={cssClass.name}>{name}</h1>
                {title && <div className={cssClass.title}>{title}</div>}
                {statement && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: statement.childMarkdownRemark.html,
                    }}
                  />
                )}
              </div>

              <Grid columns={3} className={cssClass.detailsListsContainer}>
                {specialties && (
                  <ExpandableList
                    title={specialtiesTitle}
                    stringArray={specialties}
                  />
                )}
                {diseasesTreated && (
                  <ExpandableList
                    title={diseasesTreatedTitle}
                    stringArray={diseasesTreated}
                  />
                )}
                {spokenLanguages && (
                  <SpokenLanguageList spokenLanguagesArray={spokenLanguages} />
                )}
              </Grid>

              {experience && (
                <div>
                  <h2 className={cssClass.subTitle}>{experienceTitle}</h2>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: experience.childMarkdownRemark.html,
                    }}
                  />
                </div>
              )}

              {training && (
                <div>
                  <h2 className={cssClass.subTitle}>{trainingTitle}</h2>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: training.childMarkdownRemark.html,
                    }}
                  />
                </div>
              )}
            </div>
          </Grid>
        </Section>
      </Layout>
    );
  }
}

export default injectIntl(TeamMember);

export const query = graphql`
  query($slug: String!, $locale: String) {
    contentfulTeamMember(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      image {
        title
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      name
      title
      slug
      statement {
        childMarkdownRemark {
          html
        }
      }
      specialties
      diseasesTreated
      spokenLanguages {
        id
        name
        image {
          title
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
      experience {
        childMarkdownRemark {
          html
        }
      }
      training {
        childMarkdownRemark {
          html
        }
      }
      metaDescription
    }
    contentfulTeamMemberPage(node_locale: { eq: $locale }) {
      backToClinicLink
      specialtiesTitle
      diseasesTreatedTitle
      experienceTitle
      trainingTitle
    }
  }
`;
